import type { Column } from "@tanstack/react-table";

import { cn } from "@/lib/utils";

interface DataTableColumnHeaderProps<TData, TValue>
  extends React.HTMLAttributes<HTMLDivElement> {
  column: Column<TData, TValue>;
  title: string;
}

export function DataTableColumnHeader<TData, TValue>({
  column: _column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  return <div className={cn(className)}>{title}</div>;
}
